export default "__VITE_ASSET__Bt2jr5Nl__"